import { createOceanyAuth } from "@vida/oceany-auth";
import {
  getClientId,
  getCognitoDomain,
  getLoginUrl,
  getPostLogoutRedirect,
  getRedirectUri,
  getSessionBrokerUrl,
} from "./config";

export type { TokenBundle } from "@vida/oceany-auth";

const auth = createOceanyAuth({
  storageKeyPrefix: "oceany_app",
  getClientId,
  getCognitoDomain,
  getRedirectUri,
  getPostLogoutRedirect,
  getSessionBrokerUrl,
  getLoginUrl,
  loginAlertMessage: "Config OAuth mancante per il launcher Oceany.",
});

export const SK_RETURN_PATH = auth.SK_RETURN_PATH;
export const {
  loadTokens,
  saveTokens,
  clearTokens,
  saveReturnPath,
  consumeReturnPath,
  clearOAuthSession,
  performLogout,
  startLogin,
  handleOAuthCallback,
  restoreSessionOnStartup,
  requireSession,
  refreshIfNeeded,
  forceRefreshTokens,
  getIdToken,
  decodeJwtPayload,
  currentUserEmail,
  redirectToLogin,
} = auth;
